<template>
  <div class="wxRenewDatail">
    <van-row class="cell">
      <van-row class="border cell-body">
        <van-col span="6" class="title">客户名称</van-col>
        <van-col
          span="18"
          class="rightText"
          @click.native="linkSkip('customerDetail',{companyId:customer.companyId,tabIndex:0},'','')"
        >
          <span>{{customer.customerName}}</span>
          <van-icon name="arrow"/>
        </van-col>
      </van-row>
    </van-row>
    <van-row class="cell type">
      <van-row class="border cell-body">
        <van-col span="6" class="title">服务项目</van-col>
        <van-col
          v-if="currentType == 'acct'"
          span="18"
          class="rightText"
        >代理记账：{{customer.acctType == 3 ? '记账+报税' : (customer.acctType == 1 ? '记账' : '报税')}}
        </van-col>
        <van-col
          v-if="currentType == 'buss'"
          span="18"
          class="rightText"
        >{{customer.caption + (customer.itemName ? ':' + customer.itemName : '')}}
        </van-col>
      </van-row>
    </van-row>
    <van-row class="cell">
      <van-row v-if="currentType == 'acct'" class="border cell-body">
        <van-col span="6" class="title">服务总价</van-col>
        <van-col v-if="customer.hasContract" @click.native="linkSkip('acctContract')" span="18" class="rightText">
          <span>{{customer.contractAmount}}</span>
          <van-icon name="arrow"/>
        </van-col>
        <van-col v-else span="18" class="rightText">
          <span>无合同</span>
        </van-col>
      </van-row>
      <van-row v-if="currentType == 'buss'" class="border cell-body">
        <van-col span="6" class="title">{{isPeriodicServiceBeta === 1 ? '服务总价' : '合同金额'}}</van-col>
        <van-col @click.native="linkSkip('bussContract')" span="18" class="rightText">
          <span>{{customer.contractFee}}</span>
          <van-icon name="arrow"/>
        </van-col>
      </van-row>
    </van-row>
    <van-row v-if="currentType == 'acct'" class="cell">
      <van-row class="border cell-body">
        <van-col span="6" class="title">收款周期</van-col>
        <van-col span="18" class="rightText">{{customer.collectionPeriod}}</van-col>
      </van-row>
    </van-row>
    <van-row class="cell">
      <van-row v-if="currentType == 'acct'" class="cell-body">
        <van-col span="6" class="title">已收金额</van-col>
        <van-col
          v-if="customer.accepted != 0"
          @click.native="linkSkip('collectionRecord')"
          span="18"
          class="rightText"
        >
          <span>{{customer.accepted}}</span>
          <van-icon name="arrow"/>
        </van-col>
        <van-col v-else span="18" class="rightText">
          <span>{{customer.accepted}}</span>
        </van-col>
      </van-row>
      <van-row v-if="currentType == 'buss'" class="cell-body">
        <van-col span="6" class="title">已收金额</van-col>
        <van-col
          @click.native="linkSkip('collectionRecord_buss')"
          span="18"
          class="rightText"
        >
          <span>{{customer.totalFee}}</span>
          <van-icon name="arrow"/>
        </van-col>
      </van-row>
    </van-row>
    <div v-if="env == 'miniprogram'">
      <van-row v-if="currentType == 'acct'" class="cell type">
        <van-row class="border cell-body">
          <van-col span="8" class="title">收款开始期间</van-col>
          <van-col span="16" class="rightText">{{formatDate(beginDate)}}</van-col>
        </van-row>
      </van-row>
      <van-row v-if="currentType == 'acct'" class="cell">
        <van-row class="border cell-body">
          <van-col span="8" class="title">收款结束期间</van-col>
          <van-col span="16" class="rightText">{{formatDate(endDate)}}</van-col>
        </van-row>
      </van-row>
      <van-row class="cell border-gray">
        <van-row class="cell-body">
          <van-col span="6" class="title">应收金额</van-col>
          <van-col v-if="currentType == 'acct'" span="18" class="rightText">{{customer.lackFeeAmount}}</van-col>
          <van-col v-if="currentType == 'buss'" span="18" class="rightText">{{customer.surplusFee}}</van-col>
        </van-row>
      </van-row>
      <van-row class="explain-text" @click="showPopup = true">
        <span>绑定微信公众号后可在公众号里使用微信收款</span>
        <van-icon name="arrow"/>
      </van-row>
      <!-- <van-row class="btnRow disabled">发起微信收款</van-row> -->
    </div>
    <div v-else>
      <van-row v-if="currentType == 'acct'" class="cell type">
        <van-row  class="border cell-body">
          <van-col span="8" class="title">收款开始期间</van-col>
          <van-col span="16" class="rightText">
            <date-picker
              @dateChange="beginDateChange($event)"
              :isRowPicker="true"
              :min-date="minDate"
              :max-date="maxDate"
              :title="'收款开始期间'"
              :currentMonth="beginDate"
            ></date-picker>
          </van-col>
        </van-row>
      </van-row>
      <van-row v-if="currentType == 'acct'" class="cell">
        <van-row class="border cell-body">
          <van-col span="8" class="title">收款结束期间</van-col>
          <van-col span="16" class="rightText">
            <date-picker
              @dateChange="endDateChange($event)"
              :isRowPicker="true"
              :min-date="minDate"
              :max-date="maxDate"
              :title="'收款结束期间'"
              :currentMonth="endDate"
            ></date-picker>
          </van-col>
        </van-row>
      </van-row>
      <van-row :class="currentType == 'acct' ? 'cell border-gray' : 'cell border-gray type'">
        <van-row v-if="currentType == 'acct'" class="border cell-body">
          <van-col span="6" class="title">应收金额</van-col>
          <van-col
            @click.native="linkSkip('dueAmount',{lackFeeAmount:lackFeeAmount})"
            span="18"
            class="rightText"
          >
            <span>{{lackFeeAmount}}</span>
            <van-icon name="arrow"/>
          </van-col>
        </van-row>
        <van-row v-if="currentType == 'buss'" class="cell-body">
          <van-col span="6" class="title">应收金额</van-col>
          <van-col
            @click.native="linkSkip('dueAmount_buss',{lackFeeAmount_buss:lackFeeAmount_buss})"
            span="18"
            class="rightText"
          >
            <span>{{lackFeeAmount_buss}}</span>
            <van-icon name="arrow"/>
          </van-col>
        </van-row>
      </van-row>
      <van-row class="cell type receipts">
        <van-row  class="border cell-body">
          <van-col span="8" class="title">收款备注</van-col>
          <van-col span="16" class="rightText">
            <van-field
              v-model="receipts"
              @input="filterEmoji"
              rows="1"
              autosize
              type="textarea"
              maxlength="50"
              placeholder="给客户看的补充说明"
            />
          </van-col>
        </van-row>
      </van-row>


      <van-row v-show="env != 'miniprogram' && isIncomplete" class="explain-text" @click="needEditContract = true">
        <span>收款期间对应的合同信息不完整</span>
        <van-icon name="arrow"/>
      </van-row>

      <van-row v-show="env != 'miniprogram' && isNoContract" class="explain-text" @click="needContract = true">
        <span>收款期间没有合同</span>
        <van-icon name="arrow"/>
      </van-row>

      <van-row
        v-if="currentType == 'acct'"
        @click.native="linkSkip('wechatCollection',{beginDate:beginDate,endDate:endDate,lackFeeAmount:lackFeeAmount,receipts:receipts},'','70000004')"
        class="btnRow"
      >发起微信收款
      </van-row>
       <!-- <van-row
        v-if="(currentType == 'acct' && isIncomplete) || (currentType == 'acct' && isNoContract)"
        class="btnRow disabled"
      >发起微信收款
      </van-row> -->
      <van-row
        v-if="currentType == 'buss'"
        @click.native="linkSkip('wechatCollection_buss',{lackFeeAmount_buss:lackFeeAmount_buss,receipts:receipts},'','70000004')"
        class="btnRow"
      >发起微信收款
      </van-row>
    </div>
    <van-popup v-model="showPopup" class="miniprogram-popup">
      <div>
        <div class="title">如何绑定微信公众号？</div>
        <div class="content">请通过电脑网页端登录账无忧代账管家，点击【微信运营】-【公众号管理】，根据系统向导即可完成公众号绑定</div>
        <div class="ikow" @click="showPopup = false">我知道了</div>
      </div>
    </van-popup>
    <van-popup v-model="needEditContract" class="miniprogram-popup">
      <div>
        <div class="title">合同信息不完整</div>
        <div class="content" style="text-indent: 0;">当前收款期间【{{beginDate + '~' + endDate}}】对应的合同信息不完整，建议重新选择收款期间。</div>
        <div class="sub-content">注：请通过电脑网页端登录账无忧代账管家，点击【客户】-【合同】进行修改。</div>
        <div class="ikow" @click="needEditContract = false">我知道了</div>
      </div>
    </van-popup>
    <van-popup v-model="needContract" class="miniprogram-popup">
      <div>
        <div class="title">没有合同信息</div>
        <div class="content" style="text-indent: 0;">当前收款期间【{{beginDate + '~' + endDate}}】没有对应的合同，建议重新选择收款期间。</div>
        <div class="sub-content">注：请通过电脑网页端登录账无忧代账管家，点击【客户】-【合同】进行新增。</div>
        <div class="ikow" @click="needContract = false">我知道了</div>
      </div>
    </van-popup>
    <van-popup v-model="applyDialog" class="applyDialog-popup miniprogram-popup">
      <div>
        <div class="title">请先开通微信收款</div>
        <div class="content">您的公司还未开通微信收款功能，无法发起微信收款</div>
        <div v-if="applyStatus == 0 || applyStatus == 1 || applyStatus == 3" class="popup-btnRow"><span class="btn default" @click="applyDialog = false">下次再说</span><span class="btn primry" @click="linkSkip('applyRate')">现在去开通</span></div>
        <div v-else class="popup-btnRow"><span class="btn default" @click="applyDialog = false">下次再说</span><span class="btn primry" @click="linkSkip('applyCollection')">现在去开通</span></div>
      </div>
    </van-popup>
    <van-popup v-model="moneyNoEnoughDialog" class="moneyNoEnoughDialog-popup miniprogram-popup">
      <div>
        <div class="title">余额不足</div>
        <div class="content">您的余额为{{balance}}元，余额不足，请到账无忧代账管家服务商城页面进行充值</div>
        <div class="ikow" @click="moneyNoEnoughDialog = false">我知道了</div>
      </div>
    </van-popup>
  </div>
</template>

<script>
import Vue from "vue";
import { Row, Col, Icon, Popup, Toast, Field  } from "vant";
import DatePicker from "@/components/DatePicker.vue";
import moment from "moment";
import wx from "weixin-js-sdk";
Vue.use(Row)
  .use(Col)
  .use(Icon)
  .use(Popup)
  .use(Field);

export default {
  name: "wxRenewDatail",
  components: {
    DatePicker
  },
  data() {
    return {
      isPeriodicServiceBeta: parseInt(sessionStorage.getItem('_isPeriodicServiceBeta')) || 0,
      minDate: new Date((new Date().getFullYear() - 20) + "/01/01") ,
      maxDate: new Date((new Date().getFullYear() + 20) +  "/12/31") ,
      customer: this.$store.state.wechatCollectionInfo,
      currentType: this.$route.query.currentType,
      year: new Date().getFullYear(),
      month: new Date().getMonth() + 1,
      env: "",
      showPopup: false,
      lackFeeAmount: 0,
      lackFeeAmount_buss: 0,
      beginDate: "",
      endDate: "",
      applyDialog: false,
      moneyNoEnoughDialog: false,
      applyStatus: -1,
      moneyEnough: true,
      // canUseAmount: 0,
      // needAmount:0,
      receipts:'',
      balance:0,
      isNeedCheck:false,
      powerData:this.$store.state.powerData,
      contractStartDate:new Date('1970/01/01'),
      contractEndDate:new Date('2200/01/01'),
      needEditContract:false,
      needContract:false,
      isIncomplete:false,
      isNoContract:false
    };
  },

  methods: {
    init() {
      this.beginDate =
        this.$store.state.dueAmountDateInfo.beginDate ||
        this.customer.lackFeePeriodStart ||
        sessionStorage.getItem("_defaultCollectionPeriods");
      this.endDate =
        this.$store.state.dueAmountDateInfo.endDate ||
        this.customer.lackFeePeriodEnd ||
        sessionStorage.getItem("_defaultCollectionPeriods")
      this.lackFeeAmount = this.$route.query.lackFeeAmount || this.$store.state.collectionTypeInfo.lackFeeAmount || 0
      
      if(this.currentType == 'acct' && !this.$route.query.lackFeeAmount && !this.$store.state.collectionTypeInfo.lackFeeAmount){
        this.getReceivable();
      }

      this.lackFeeAmount_buss = this.$route.query.lackFeeAmount_buss || this.customer.surplusFee || 0
      this.getRnv();
      this.getApplyAndMoneyInfo();
      this.getIsNeedToCheck();
      if(this.currentType == 'acct'){
        this.getContractInfo();
      }
    },

    //获取某个时间段内所有的月份，返回数组，前后闭区间
    getMonthBetween(start,end){
      var result = [];
      var starts = start.split('-');
      var ends = end.split('-');
      var staYear = parseInt(starts[0]);
      var staMon = parseInt(starts[1]);
      var endYear = parseInt(ends[0]);
      var endMon = parseInt(ends[1]);
      while (staYear <= endYear) {
          if (staYear === endYear) {
              while (staMon <= endMon) {
                  staMon++;
                  result.push(staYear + '-' + ((staMon-1) > 9 ? (staMon-1) : ('0' + (staMon-1))));
              }
              staYear++;
          } else {
              staMon++;
              if (staMon > 12) {
                  staMon = 1;
                  staYear++;
              }
              if((staMon-1) == 0){
                  result.push(staYear-1 + '-12');
              }else{
                  result.push(staYear + '-' + ((staMon-1) > 9 ? (staMon-1) : ('0' + (staMon-1))));
              }
          }
      }
      return result; 
    },
    //代账服务收款本次收款金额需要后端计算返回
    getReceivable() {
      let isAf = moment(this.endDate).isAfter(this.beginDate);
      if (!isAf && !moment(this.endDate).isSame(this.beginDate)) {
        Toast("结束期间小于开始期间，请重新选择！");
        return;
      }
      let periodStr = this.getMonthBetween(this.beginDate,this.endDate).join(',');

      let url = "/fc/small/program/month/amount?companyId=" + this.customer.companyId + "&period=" + periodStr
      this.$http
        .get(url)
        .then(res => {
          if (res.data.code == 200) {

           this.lackFeeAmount = res.data.data && res.data.data.receivable;

           if(res.data.data.hasContract == 1){
              sessionStorage.setItem('_hasContract','1')
           }else{
              sessionStorage.setItem('_hasContract','0')
           }

           sessionStorage.setItem('_allReceivale', res.data.data.allReceivale == 1 ? '1' : '0')

           this.$store.dispatch("setCollectionTypeInfo", {
            AmountList: [
              0,
              0,
              0,
              0,
              0,
              0,
              0,
              0,
              0,
              0,
              0,
              0,
              0,
              0,
              0,
              0,
              0,
              0,
              0,
              0
            ],
            discount: 0,
            serviceFee:0
          });

          this.$store.dispatch("setLackFeeAmount",this.lackFeeAmount);

          } else {
            Toast(res.data.msg);
          }
        })
        .catch(error => {
          Toast(error);
        });
    },
    getRnv() {
      const ua = navigator.userAgent.toLowerCase();
      if (ua.match(/MicroMessenger/i) == "micromessenger") {
        //ios的ua中无miniProgram，但都有MicroMessenger（表示是微信浏览器）
        wx.miniProgram.getEnv(res => {
          if (res.miniprogram) {
            this.env = "miniprogram";
          } else {
            this.env = "public";
          }
        });
      } else {
        this.env = "public";
      }
    },
    //判断职员权限
    estimatePower (menuName,tabName,operateName) {
      for(let i=0,lenI=this.powerData.length;i<lenI;i++){
        //  判断菜单名
        if(menuName==this.powerData[i].name){
          for(let j=0,lenJ=this.powerData[i].children.length;j<lenJ;j++){
            //  判断页签名
            if(tabName==this.powerData[i].children[j].name){

              if(!operateName){
                 return this.powerData[i].children[j].status;
              }else{
                for(let k=0,lenK=this.powerData[i].children[j].children.length;k<lenK;k++){
                  //  判断
                  if(operateName==this.powerData[i].children[j].children[k].name){
                    return this.powerData[i].children[j].children[k].checked;
                  }
                }
              }
            }
          }
        }
      }
    },
    getApplyAndMoneyInfo() {
      let url = (this.currentType == 'acct' ? "/fc/small/program/check/applyInfo?payAmount=" + this.lackFeeAmount : "/fc/small/program/check/applyInfo?payAmount=" + this.lackFeeAmount_buss)
      this.$http
        .get(url)
        .then(res => {
          if (res.data.code == 200) {
            let rdata = res.data.data;
            this.applyStatus = rdata.applyStatus || -1;
            if (Number(rdata.balance) < 0 && !rdata.currStatus){
              this.moneyEnough = false
            }else{
              this.moneyEnough = true
            }
            this.balance = rdata.balance;
            // this.canUseAmount = rdata.canUseAmount;
            // this.needAmount = rdata.needAmount;
          } else {
            Toast(res.data.msg);
          }
        })
        .catch(error => {
          Toast(error);
        });
    },
    //获取是否勾选合同需审核才能收款
    getIsNeedToCheck() {
      this.$http
        .get("/fc/small/program/check/conrenew?key=conRenewToFee")
        .then(res => {
          if (res.data.code == 200) {
            this.isNeedCheck = res.data.data;
          } else {
            Toast(res.data.msg);
          }
        })
        .catch(error => {
          Toast(error);
        });
    },
    //获取当前所选期间是否有合同或者合同信息是否完整
    getContractInfo() {
      let isAf = moment(this.endDate).isAfter(this.beginDate);
      if (!isAf && !moment(this.endDate).isSame(this.beginDate)) {
        Toast("结束期间小于开始期间，请重新选择！");
        return;
      }
      let periodStr = this.getMonthBetween(this.beginDate,this.endDate).join(',')
      let params = {
        period:periodStr,
        companyId:this.customer.companyId
      }
      this.$http
        .post("/fc/small/program/check/fee",params)
        .then(res => {
          if (res.data.code == 200) {
           if(res.data.data.contractId == -2){
             this.isNoContract = true;
           }else if(res.data.data.contractId == -1){
             this.isIncomplete = true;
           }else{
             this.isNoContract = false;
             this.isIncomplete = false;
           }
           
          } else {
            Toast(res.data.msg);
          }
        })
        .catch(error => {
          Toast(error);
        });
    },
    linkSkip(name, params, redType, rid) {
      if (rid) {
        this.$root.$emit("log-record", rid);
      }
      if (name == "wechatCollection") {
        if(!this.estimatePower("财务管理","收款跟进","收款")){
          Toast("没有权限：收款跟进-收款");
          return;
        }
        //勾选了需要审核才能收款且未审核的合同不能收款，提示当前合同未审核，不能收款
        if(this.isNeedCheck && this.customer.conStatus == 1){
          Toast("当前合同未审核，不能收款！");
          return
        }
        this.getApplyAndMoneyInfo();
        let isAf = moment(this.endDate).isAfter(this.beginDate);
        if (!isAf && !moment(this.endDate).isSame(this.beginDate)) {
          Toast("结束期间小于开始期间，请重新选择！");
          return;
        }
        if(this.applyStatus != 2){
          this.applyDialog = true;
          return
        }
        if(!this.moneyEnough){
          this.moneyNoEnoughDialog = true;
          return
        }
        if(this.lackFeeAmount == 0){
          Toast("应收金额不能为0！");
          return
        }
      }
      if (name == "wechatCollection_buss") {
        if(!this.estimatePower("财务管理","收款跟进","收款")){
          Toast("没有权限：收款跟进-收款");
          return;
        }
        //勾选了需要审核才能收款且未审核的合同不能收款，提示当前合同未审核，不能收款
        if(this.isNeedCheck && this.customer.conStatus == 1){
          Toast("当前合同未审核，不能收款！");
          return
        }
        this.getApplyAndMoneyInfo();
        
        if(this.applyStatus != 2){
          this.applyDialog = true;
          return
        }
        if(!this.moneyEnough){
          this.moneyNoEnoughDialog = true;
          return
        }
        if(this.lackFeeAmount_buss == 0){
          Toast("应收金额不能为0！");
          return
        }
      }
      if (name == "collectionRecord" || name == "collectionRecord_buss") {
        if(!this.estimatePower("财务管理","收款跟进","收款记录")){
          Toast("没有权限：收款跟进-收款记录");
          return;
        }
      }
      if (name == "acctContract" || name == "bussContract") {
        if(!this.estimatePower("财务管理","收款跟进","查看合同")){
          Toast("没有权限：收款跟进-查看合同");
          return;
        }
      }
      this.$router.push({
        name: name,
        query: params
      });
    },
    beginDateChange(e) {
      this.beginDate = e;
      this.computeMonths();
      this.getContractInfo();
    },
    endDateChange(e) {
      this.endDate = e;
      this.computeMonths();
      this.getContractInfo();
    },
    formatDate(date) {
      if (!date) {
        return;
      }
      return date.split("-")[0] + "年" + date.split("-")[1] + "月";
    },
    computeMonths() {
      // let a = moment(this.beginDate);
      // let b = moment(this.endDate);
      // let bmonths = b.diff(a, "months") + 1;
      // let isAf = moment(this.endDate).isAfter(this.beginDate);
      // if (!isAf) {
      //   Toast("结束期间小于开始期间，请重新选择");
      //   return;
      // }
      this.$store.dispatch("setDueAmountDateInfo", {
        beginDate: this.beginDate,
        endDate: this.endDate
      });

      this.getReceivable();
    },
    filterEmoji(){
      // eslint-disable-next-line no-useless-escape
      let patt = /[\uD83C|\uD83D|\uD83E][\uDC00-\uDFFF][\u200D|\uFE0F]|[\uD83C|\uD83D|\uD83E][\uDC00-\uDFFF]|[0-9|*|#]\uFE0F\u20E3|[0-9|#]\u20E3|[\u203C-\u3299]\uFE0F\u200D|[\u203C-\u3299]\uFE0F|[\u2122-\u2B55]|\u303D|[\A9|\AE]\u3030|\uA9|\uAE|\u3030/ig
      this.receipts = this.receipts && this.receipts.replace(patt,'')
    }
  },
  mounted: function() {
    this.$root.$emit('log-record',"70000003");
    //滚动条置顶
    document.documentElement.scrollTop = document.body.scrollTop = 0;
    this.init();
  }
};
</script>

<style type="text/css" lang="stylus" scoped>
.wxRenewDatail {
  position: relative;
  padding-bottom: 0.8rem;

  .cell {
    background-color: #ffffff;
    font-size: 0.16rem;
    padding-left: 0.16rem;
  }

  .cell-body {
    padding: 0.11rem;
    padding-left: 0;
  }

  .title {
    color: #1A2633;
    font-size: 0.17rem;
  }

  .rightText {
    text-align: right;
    color: #516374;
    font-size: 0.14rem;
    line-height: 0.23rem;
  }

  .leftText {
    color: #516374;
    font-size: 0.14rem;
  }

  .type {
    margin-top: 0.08rem;
  }

  .margnTop {
    margin-top: 0.1rem;
  }

  .task {
    color: #516374;
  }

  .pcolor {
    color: #1fadf6;
  }

  .border {
    border-bottom: 1px solid #f0f2f2;
  }

  .btnRow {
    padding: 0.16rem 0.12rem;
    text-align: center;
    color: #1FADF6;
    background-color: #ffffff;
    border-top: 1px solid #f0f2f2;
    position: fixed;
    width: 100%;
    bottom: 0;
    left: 0;
    font-size: 0.17rem;
    box-sizing: border-box;
    font-weight: 500;
  }

  .btnRow.disabled {
    color: #B4BEC7;
  }

  .explain-text {
    color: #FF8464;
    text-align: center;
    width: 100%;
    margin-top: 0.12rem;
  }

  .miniprogram-popup {
    width: 3rem;
    border-radius: 0.06rem;

    .title {
      padding: 0.24rem 0;
      text-align: center;
      font-size: 0.17rem;
      color: #1A2633;
      font-weight: bold;
    }

    .content {
      padding: 0 0.16rem;
      text-indent: 0.2rem;
      color: #1A2633;
    }
    .sub-content{
      padding: 0 0.16rem;
      color: #716f6f;
    }

    .ikow {
      color: #1391FF;
      font-size: 0.17rem;
      text-align: center;
      margin-top: 0.32rem;
      border-top: 1px solid #EFF1F1;
      padding: 0.16rem 0;
    }
  }
  .popup-btnRow{
    text-align center
    padding 0.16rem 0
    .btn{
      display inline-block
      padding 0.06rem 0.16rem
      border-radius 50px
    }
    .btn.default{
      border 1px solid #e0e0e0
      margin-right 0.16rem
    }
    .btn.primry{
      border 1px solid #1391FF
      background-color #1391FF
      color #ffffff
    }
  }

  .van-icon-arrow {
    margin-left: 0.04rem;
    position: relative;
    top: 0.02rem;
  }
}
</style>
<style>
.wxRenewDatail .receipts textarea{
  color: #516374;
  font-size: 0.14rem;
  padding: 0;
}
.wxRenewDatail .receipts .van-cell.van-field{
  padding: 0;
}
</style>

